import { CalendarDay } from '@shared/models/dateTypes';
import { AvailabilityType } from '@features/booking';
import { ApiDateTime } from '@shared/models/models';

export interface SearchQueryParams {
  locationId: number | undefined;
  activityId: number | undefined;
  resourceId?: number;
  start: CalendarDay | null;
  end: CalendarDay | null;
}

export interface SearchResponse {
  id: number;
  parentId: number | null;
  name: string | null;
  timeslots: SearchResponseTimeslot[];
}

export interface SearchResponseTimeslot {
  availabilityType: AvailabilityType;
  resourceId: number;
  start: ApiDateTime;
  end: ApiDateTime;
  price: number;
  activityId: number | null;
  locationId: number | null;
  isAvailable: boolean;
  bookingTypeId?: number; // booking type for the timeslot
  /** Flextid step size in minutes when the slot comes from a reducible price row; null/undefined = fixed block. */
  reducibleInterval?: number | null;
  /** Korteste booking prisperioden tillader på lokalet, i minutter. Null når den ikke sætter en. */
  minBookingMinutes?: number | null;
  /** The occupying booking period (when not available). */
  bookingPeriodId?: number | null;
  /** Who booked an occupied slot — the booking period's note. */
  bookedByNote?: string | null;
  //  mutations from API model to store model
  id: string; // code mutation id_SearchResponseTimeslot_Convention
  inBasket?: boolean; // code mutation
  isLoading?: boolean; // code mutation
  hasError?: boolean; // code mutation
  // Flextid split state (code mutation) — a reducible block is shown as one clickable
  // block; once a Fra/Til span is picked it is split into a selected segment and the
  // remaining free segment(s). These carry the original block's range so the split can
  // be recomputed when a selection is added or removed.
  isReducibleSelected?: boolean; // this segment is a chosen Fra/Til span ("Valgt")
  flexParentId?: string; // id of the original reducible block this segment belongs to
  flexParentStart?: ApiDateTime; // original block start (local ISO)
  flexParentEnd?: ApiDateTime; // original block end (local ISO)
  flexPerIntervalPrice?: number; // price of a single interval, kept stable across splits
}

/** A reducible (Flextid) timeslot — one whose span the user picks in steps of reducibleInterval. */
export function isReducibleTimeslot(timeslot: SearchResponseTimeslot): boolean {
  return (timeslot.reducibleInterval ?? 0) > 0;
}

/**
 * The id a timeslot is addressed by. Both ends are interpolated straight into it, so they have to
 * be the API's own strings: a `Date` would stringify to "Sat Sep 13 2026 00:00:00 GMT+0200 (CEST)"
 * and the id would then differ by the viewer's locale and offset.
 */
export function id_SearchResponseTimeslot_Convention(
  locationId: number,
  resourceId: number,
  start: ApiDateTime,
  end: ApiDateTime,
) {
  return 'location' + locationId + '_resource' + resourceId + '_start' + start + '_end' + end;
}
